export default {
  layouts: {
    nasiya: {
      logout: 'Chiqish',
      main: 'Asosiy',
      applications: 'Arizalar',
      searchClients: 'Mijozni qidirish',
      rejects: 'Qaytarishlar',
      tickets: 'Muammolar',
      deliveries: 'Yetkazmalar',
      management: 'Menejment',
      analytics: 'Analitika',
      invoice: 'Hisob-faktura',
      sales: 'Sotuvlar',
      excels: 'Hisobotlar',
      allApplications: "Barcha do'konlarning arizalari",
      notifications: 'Xabarlar',
      bonuses: 'Bonuslar',
      installmentPayment: "Muddatli to'lovni to'lash",
      warehouse: 'Ombor',
      shipmentOffers: 'Tovarlarni topshirish',
    },
  },
};
